import {Injectable} from '@angular/core';
import { Router } from '@angular/router';
import {MaintenanceService} from '../maintenance/maintenance.service';

@Injectable()
export class MaintenanceGuardService  {

    constructor(
        private router: Router,
        private maintenance: MaintenanceService
    ) {}

    canActivate() {
        if (this.maintenance.inMaintenance) {
            return true;
        } else {
            this.router.navigate(['login']);
            return false;
        }
    }
}
